import { Link } from "react-router-dom";
import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, ACCREDITATIONS } from "../lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-ink-950">
      <div className="absolute inset-0 grid-bg-fine opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-16">
        {/* Top grid */}
        <div className="grid lg:grid-cols-12 gap-12 pb-12 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={COMPANY.logo}
                alt="USI Security Ltd"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              UK private security company providing SIA-licensed manned guarding, K9 patrols, CCTV tower hire, mobile patrols and 24/7 control room monitoring for critical infrastructure across the United Kingdom.
            </p>

            <div className="mt-7 grid sm:grid-cols-2 gap-5" data-testid="footer-offices">
              {COMPANY.offices.map((office) => (
                <div key={office.id} data-testid={`footer-office-${office.id}`} className="text-sm">
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-400 mb-2">
                    {office.name}
                  </div>
                  <div className="text-slate-300 leading-relaxed mb-2">
                    {office.address_lines.map((line, i) => (
                      <div key={i}>{line}</div>
                    ))}
                  </div>
                  <a
                    href={`tel:${office.phone_href}`}
                    className="inline-flex items-center gap-1.5 text-slate-200 hover:text-cyan-400 font-mono transition"
                  >
                    <Phone className="w-3.5 h-3.5 text-cyan-400" />
                    {office.phone}
                  </a>
                </div>
              ))}
            </div>
            <div className="mt-5 flex items-center gap-3 text-slate-300">
              <MapPin className="w-4 h-4 text-cyan-400" />
              <span className="text-sm">{COMPANY.address}</span>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-5">Services</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/services" className="text-slate-400 hover:text-white">Manned Guarding</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-white">CCTV & Surveillance</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-white">K9 Patrols</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-white">Security Systems</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-5">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="text-slate-400 hover:text-white">About</Link></li>
              <li><Link to="/industries" className="text-slate-400 hover:text-white">Industries</Link></li>
              <li><Link to="/recruitment" className="text-slate-400 hover:text-white">Careers</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-5">Accredited By</h4>
            <div className="grid grid-cols-3 gap-2">
              {ACCREDITATIONS.map((a) => (
                <div key={a.name} className="aspect-square rounded-md bg-white/5 border border-white/10 p-2 flex items-center justify-center hover:border-cyan-400/40 transition">
                  <img src={a.logo} alt={a.name} className="w-full h-full object-contain opacity-80" loading="lazy" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="text-xs text-slate-500 font-mono">
            © {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-xs text-slate-500">
            <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-cyan-400 transition">Privacy Policy</Link>
            <Link to="/quality-policy" data-testid="footer-quality" className="hover:text-cyan-400 transition">Quality Policy</Link>
            <Link to="/recruitment" data-testid="footer-careers" className="hover:text-cyan-400 transition flex items-center gap-1">
              Careers <ArrowUpRight className="w-3 h-3" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
